import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import List from 'components/atoms/list';
import useOutsideClick from 'utils/useOutsideClick';
import ResetSearchIcon from 'components/atoms/icons/searchResetIcon';
import useSearch from '../useSearch';

const loadingOptions = [{ id: 'loading', label: 'Loading...' }];

const MedicationAutocomplete = ({
  filter,
  handleClick,
  handleReset,
  inputRef,
}) => {
  const [query, setQuery] = useState('');
  if (inputRef) inputRef.current = { setValue: setQuery };
  const containerRef = useRef();
  const [show, setShow] = useState(false);

  useOutsideClick(containerRef, () => {
    setShow(false);
  });
  const { isLoading, results } = useSearch(query);

  const handleInputChange = (string) => {
    if (string.target) {
      setQuery(string.target.value);
    }
  };

  const handleOptionClick = (option) => {
    setQuery(option.label);
    handleInputChange(option.label);
    setShow(true);
    return handleClick(option);
  };

  const handleFocus = () => {
    if (filter.id === 'name') {
      setShow(true);
    }
  };
  const resetSearch = () => {
    setQuery('');
    handleInputChange('');
  };

  return (
    <div className="autocomplete autocomplete--table-input" ref={containerRef}>
      <div className="dropdown" role="button" aria-hidden>
        <Card>
          <CardBody>
            <div className="autocomplete__input-container">
              <input
                className="autocomplete__input"
                placeholder={filter.placeholder}
                type="text"
                onChange={handleInputChange}
                value={query}
                onFocus={handleFocus}
              />
              {query !== '' && (
                <ResetSearchIcon
                  onClick={() => {
                    resetSearch();
                    handleReset();
                  }}
                />
              )}
            </div>
          </CardBody>
        </Card>
      </div>
      {isLoading && show && (
        <div className="autocomplete__list">
          <List onChange={() => {}} options={loadingOptions} />
        </div>
      )}
      {!isLoading && results && results.length > 0 && show && (
        <div className="autocomplete__list">
          <List onChange={handleOptionClick} options={results} />
        </div>
      )}
    </div>
  );
};

MedicationAutocomplete.defaultProps = {
  handleReset: () => {},
};

MedicationAutocomplete.propTypes = {
  filter: PropTypes.shape().isRequired,
  inputRef: PropTypes.shape(),
  handleClick: PropTypes.func.isRequired,
  handleReset: PropTypes.func,
};

export default MedicationAutocomplete;
